module.exports = __webpack_public_path__ + "static/media/icon-segula.06303afc.svg";